export default __webpack_public_path__ + "static/media/dark-mode.f9319f54.png";